export const environment = {
  production: true,
  oneAPMId:9987763,
  transBaseUrl:'http://leaftest2.chinaeast2.cloudapp.chinacloudapi.cn:8091/',
  version: "v.1.0.0",
  appId: "1739e28a7bc179",
  appName: "transtalent"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts